import { getRequest, postRequest } from './api'

export async function list(size, index, searchTerm, orderBy) {
  
  return getRequest(`technicianDailyRecord/get-list/${size || 10}/${index || 0}/${searchTerm || '%20'}/${orderBy || '%20'}`)
}

export async function listByID(reportID) {
  return getRequest(`technicianDailyRecord/get-daily-records2/${reportID}`)
}

export async function find(id) {
  return getRequest(`technicianDailyRecord/edit/${id}`)
}

export async function save(values) {
  return postRequest(`technicianDailyRecord/save`, values)
}

export function remove(values) {
  return postRequest(`technicianDailyRecord/delete`, values)
}
